import axios from "axios";
import { apiCheckLogin, apiDangKy, apiDangNhap, apiVpos } from "./api";
import CryptoJS from "crypto-js";




 const getMD5 = (input) => {
  return CryptoJS.MD5(input).toString();
}
const header =  {
  "Access-Control-Allow-Origin": "https://vimass.vn",
  "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
  "Access-Control-Allow-Headers":
    "DNT,X-Mx-ReqToken,Keep-Alive,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range",
  "Access-Control-Allow-Credentials": "true",
  "Access-Control-Max-Age": 3600,
  "Access-Control-Expose-Headers": "Content-Length",
}
const codeCheckSum = "0819226669jdqpowrifioefiqo3289r79f";
const currentTime = new Date().getTime();
const userLapTrinh = "0979951954";

//check login
export const getCheckLoginUser = (idVi ) => {
  
  var cks = getMD5(currentTime + "1216546" + idVi + userLapTrinh)

  return axios
    .get(apiCheckLogin + currentTime+"_"+cks+"_"+idVi+"_"+userLapTrinh,
    {
      headers: header,
    })
    .then((res) => {
      return res.data;
    });
};
//  dang nhap
export const postLogin = (user, pass,deviceId,  VimassMH, companyCode,  type) => {
  return axios
    .post(apiDangNhap, { user,   pass,   deviceId,  VimassMH,   companyCode,  type,  },
    {
      headers: header,
    })
    .then((res) => {
      return res.data;
    });
};
//  dang ky
export const postResgister = (phone, pass ) => {
  var funcId = 21;
  var deviceId = 4;
  var appId = 1;
  return axios
    .post(apiDangKy, { phone,   pass, appId,  deviceId,  funcId },
    {
      headers: header,
    })
    .then((res) => {
      return res.data;
    });
};
//postLayDsStore
export const postLayDsStore = (sessionLogin, idLogin,accOwner ) => {
  var funcId = 2
  var timeRequest = currentTime;
  var companyCode = "";
  var typeLogin = 0;
  var idStore = "";
  var mcId = "";
  var limit = 20; 
  var offset= 0;

  var cksInput = getMD5(codeCheckSum + sessionLogin + idLogin + typeLogin + idStore + timeRequest + limit + offset);
  console.log({funcId,sessionLogin,idLogin,typeLogin,accOwner,companyCode,idStore,mcId,timeRequest,cksInput, limit,offset})
  return axios
    .post(apiVpos, {funcId,sessionLogin,idLogin,typeLogin,accOwner,companyCode,idStore,mcId,timeRequest,cksInput,limit,offset},
    {
      headers: header,
    })
    .then((res) => {
      return res.data;
    });
};
